/** @jsx jsx */

import { RefObject } from 'react';

import { jsx } from '@emotion/core';
import { Button, Popover, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

type Props = {
  isCode: boolean;
  isOpen: boolean;
  onClickButton: () => void;
  onOpenChange: (isOpen: boolean) => void;
  triggerRef: RefObject<Element>;
};

function ToggleModal({
  isCode,
  isOpen,
  onClickButton,
  onOpenChange,
  triggerRef,
}: Props) {
  const onClick = () => {
    onClickButton();
    onOpenChange(false);
  };

  const link = (
    <Link href={`${BASE_DOC_URL_VB}/build/code-mode`} target="_blank">
      Learn More
    </Link>
  );

  return (
    <Popover
      color="light"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="top left"
      shouldCloseOnInteractOutside={() => true}
      style={{ maxWidth: '350px', padding: '20px' }}
      title={isCode ? 'Use a simple form' : 'Write code for greater control'}
      triggerRef={triggerRef}
    >
      {isCode ? (
        <Text color="GrayWarm7" margin="10px 0px 10px 0px" tag="p">
          Switch back to form mode for simple API calls without post-processing.
          Your code will be saved but not used, and new form data will not be
          added to code mode. {link}.
        </Text>
      ) : (
        <Text color="GrayWarm7" margin="10px 0px 10px 0px" tag="p">
          Switch to code mode to customize the API call and add post-processing
          in JavaScript. Zapier will convert your form entry to code the first
          time you switch to code mode. {link}.
        </Text>
      )}
      <Button
        aria-label={
          isCode ? 'Confirm Switch to Form Mode' : 'Confirm Switch to Code Mode'
        }
        isFullWidth={true}
        onPress={onClick}
      >
        {isCode ? 'Switch to Form Mode' : 'Switch to Code Mode'}
      </Button>
    </Popover>
  );
}

export default ToggleModal;
